import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaZamowienie = () => (
  <SeoPageLayout title="Kabaret na zamówienie - spersonalizowany występ kabaretowy">
    <p>
      Kabaret na zamówienie to usługa, w ramach której przygotowujemy występ kabaretowy szyty na miarę Twojego wydarzenia. Od treści skeczów, przez tematykę, po formę występu - wszystko jest dopasowane do Twoich potrzeb, oczekiwań i specyfiki publiczności.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Czym jest kabaret na zamówienie?</h2>
    <p>
      To nie gotowy program z półki - to unikalne przedstawienie tworzone specjalnie dla Ciebie. Nasi scenarzyści i aktorzy przygotowują materiał oparty na informacjach o firmie, branży, uczestnikach i kontekście wydarzenia. Efekt? Występ, który trafia idealnie w punkt i jest niepowtarzalny.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Co można spersonalizować?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Tematykę skeczów - nawiązania do branży, firmy, aktualnych wydarzeń</li>
      <li>Postacie - parodie znanych osób z branży lub firmy (po uzgodnieniu)</li>
      <li>Język i styl - od formalnego po luźny, od subtelnego po ekspresyjny</li>
      <li>Czas trwania - od 15-minutowych wstawek po pełnogodzinne show</li>
      <li>Formę - scenki, monologi, improwizacje, kabaret muzyczny</li>
      <li>Elementy interaktywne - udział publiczności, konkursy, quizy</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Proces tworzenia kabaretu na zamówienie</h2>
    <p>
      Tworzenie spersonalizowanego kabaretu to wieloetapowy proces. Rozpoczynamy od wywiadu z klientem, podczas którego poznajemy firmę, jej kulturę, historię i specyfikę. Następnie nasi scenarzyści tworzą materiał, który jest konsultowany z klientem przed ostatecznym zatwierdzeniem.
    </p>

    <h3 className="text-xl font-bold text-foreground mt-6">Etapy realizacji</h3>
    <ol className="list-decimal pl-6 space-y-2">
      <li>Briefing - poznajemy Twoje oczekiwania i specyfikę wydarzenia</li>
      <li>Scenariusz - nasi autorzy tworzą spersonalizowany materiał</li>
      <li>Konsultacja - prezentujemy zarys programu do akceptacji</li>
      <li>Próby - artyści przygotowują się do występu</li>
      <li>Występ - profesjonalne wykonanie na Twoim wydarzeniu</li>
    </ol>

    <h2 className="text-2xl font-bold text-foreground mt-10">Ile kosztuje kabaret na zamówienie?</h2>
    <p>
      Koszt kabaretu na zamówienie zależy od stopnia personalizacji, liczby artystów, czasu trwania i lokalizacji. Skontaktuj się z nami, a przygotujemy indywidualną wycenę dopasowaną do Twojego budżetu.
    </p>
  </SeoPageLayout>
);

export default KabaretNaZamowienie;
